







































































































import Vue from 'vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import PlaylistsPanelStudentItemCard from '@/web/components/products/PlaylistsPanelStudentItemCard';
import { BCollapse } from 'bootstrap-vue';
import SortOrder from '@/core/typings/enums/SortOrder';
import RightBlockSourceType from '@/core/typings/enums/RightBlockSourceType';
import { cleanedFileName } from '@/core/utils/utils';

export default Vue.extend({
  name: 'StudioMediaDetailsSidebar',
  components: {
    PlaylistsPanelStudentItemCard,
    BCollapse,
  },
  props: {
    source: {
      type: String,
      default: RightBlockSourceType.PLAYLIST,
    },
    sourceTitle: {
      type: String,
    },
    media: {
      type: Object,
      required: true,
    },
    playlist: {
      type: Object,
    },
    sortOrder: {
      type: String,
      default: SortOrder.ASC,
    },
  },
  data() {
    return {
      isExpanded: true,
      activeMedia: null,
      activeAttachment: null,
      onPageLoadActiveMedia: false,
      sortedPlaylistContent: [],
    };
  },
  methods: {
    getCorrectRoute({ source, playlist_id, media_id, isMediaLocked }) {
      if (isMediaLocked) {
        return {
          name: 'studio-product-checkout',
          params: { product_id: this.$route.params.product_id },
        };
      }
      if (source === RightBlockSourceType.PLAYLIST) {
        return {
          name: 'studio-playlist-media',
          params: { playlist_id, media_id },
        };
      }
      return {
        name: 'studio-lesson-media',
        params: {
          product_id: this.$route.params.product_id,
          lesson_id: this.$route.params.lesson_id,
          media_id,
        },
      };
    },
    setActiveMedia() {
      this.onPageLoadActiveMedia = true;
    },
    isMediaActive(index, media) {
      return (
        index === this.activeMedia || this.$route.params.media_id == media.id
      );
    },
    isAttachmentActive(index, attachment) {
      return index === this.activeAttachment;
    },
    downloadAttachment(file) {
      return window.open(file.storage_url, '_blank');
    },
    sortPosition(items) {
      this.sortedPlaylistContent = items.sort((a, b) => {
        if (this.sortOrder === SortOrder.ASC) {
          return b.position - a.position;
        }
        return a.position - b.position;
      });
    },
    cleanedFileName,
  },
  mounted() {
    this.setActiveMedia();
  },
  watch: {
    'playlist.content': {
      handler(current, prev) {
        if (current && current !== prev) {
          this.sortPosition([...current]);
        }
      },
      immediate: true,
    },
  },
});
